export default (state = true, action) => {
  switch (action.type) {
    case  'SET_LOADED':
      return false
    default:
      return state
  }
}